import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {

    transform(key: any, allTranslations: any[], selectedlanguage: string): any {
        var selectedTranslations = allTranslations.filter(c => { return selectedlanguage == null || c.Lang == selectedlanguage })
        var v = selectedTranslations.find(c => c.Key == key);
        return v == null ? key : v.Value;
    }

}